<template>
    <QuickformBaseForm hasReturn :booking="getQuickformState(departures)" />
</template>

<script setup lang="ts">
import { getQuickformState } from "@/helpers/quickformHelpers";
import { useQuickFormStore } from "@/store/quickFormStore";
import { computed } from "vue";
import QuickformBaseForm from "./QuickformBaseForm.vue";

const quickFormStore = useQuickFormStore();

const departures = computed(() => quickFormStore.getDepartures);
</script>

<style scoped></style>
